import EntryCard from "@/components/feature/EntryCard";
import { entries } from "@/mocks/entries";

export default function RelatedEntries({ currentSlug, category }: { currentSlug: string; category: string }) {
  const sameCategory = entries.filter((e) => e.slug !== currentSlug && e.category === category);
  const others = entries.filter((e) => e.slug !== currentSlug && e.category !== category);
  const related = [...sameCategory, ...others].slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="w-full border-t border-background-200 bg-background-100 px-4 py-12 md:px-10 md:py-16">
      <div className="mb-8 flex items-end justify-between gap-4">
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">相关词条推荐</h2>
        <span className="hidden text-sm text-foreground-500 sm:block">同话题优先</span>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((entry) => (
          <EntryCard key={entry.slug} entry={entry} />
        ))}
      </div>
    </section>
  );
}